import { ShowroomTabIndex } from "../../showroom/showroom-types";
import { DesignerBoardApi, DesignerChange } from "../designer.board.api";

//export type DesignMode = "pages" | "grids";

export enum BoardTabIndex {
  None = -1,
  Start,
  Layouts,
  Grids,
  Elements,
  Products,
  Images,
  Layers,
  Settings,
  Clipboard,
}

export enum LayoutTabIndex {
  None = -1,
  Design,
  Templates,
  Products,
  Layers,
  Test,
  Settings,
  Clipboard,
}

export enum TemplateTabIndex {
  None = -1,
  Products,
  Design,
  Fields,
  Layers,
  Test,
  Settings,
  Clipboard,
}

export type DesignerTabIndex =
  | BoardTabIndex
  | LayoutTabIndex
  | TemplateTabIndex
  | ShowroomTabIndex;

export type DesignSidebarProps = {
  api: DesignerBoardApi;
  onChange: (change: DesignerChange) => void;
  openGridEditor: () => void;
  onTogglePanel: () => void;
  openCatalogDownload?: () => void;
  openProductListEditor?: () => void;
  openCatalogPublish?: () => void;
  openCatalogShare?: () => void;
  openCatalogPreview?: () => void;
};

export type SettingsTabArg = "page" | "catalog" | "catalog:headfoot";
